<div class="page-container">
    <div class="page-header">
      <img class="page-icon" src="/assets/images/Icons/Icon_Search.svg" alt="Viewer-Icon">
      <h2>Search</h2>
    </div>
<app-display-filelist [showCheckboxes]="true"></app-display-filelist>
</div>